module.exports = __webpack_public_path__ + "static/img/bg_web_top.6e490b04.jpg";